import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import React, { useCallback, useState } from 'react';
import { memoNamed } from '../utils/react/memo-named';
import { Page } from './App';
import { Root, H3, Hr, Explanation } from './common/styled';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Checkbox from '@material-ui/core/Checkbox';
interface Props {
  turnOnIsAdminFlag: () => void;
  goToPage: (page: Page) => void;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    textField: {
      margin: theme.spacing(2),
    },
    button: {
      margin: theme.spacing(2),
    },
    privacyPolicy: {
      margin: theme.spacing(2),
      height: '300px',
      border: 'solid',
      borderWidth: '1px',
      overflow: 'scroll',
    },
    checkbox: {
      margin: theme.spacing(2),
    },
    message: {
      margin: theme.spacing(2),
      color: 'red',
    },
  })
);

export const SignUpPage = memoNamed<Props>('SignUpPage', (props: Props) => {
  const [message, setMessage] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [signUpEmail, setSignUpEmail] = useState<string>('');
  const [signUpPassword, setSignUpPassword] = useState<string>('');
  const [signUpId, setSignUpId] = useState<string>('');
  const [privacyPolicyConfirmed, setPrivacyPolicyConfirmed] = useState<boolean>(
    false
  );
  const classes = useStyles();
  // 新規登録ボタンをクリック
  const onSignUpClick = useCallback(
    (event: React.FormEvent<HTMLFormElement>) => {
      event.preventDefault();
      if (!privacyPolicyConfirmed) {
        setMessage(
          'プライバシーポリシーをご確認の上、「同意する」にチェックを入れてください。'
        );
        return;
      }
      setIsLoading(true);
      const db = firebase.firestore();
      // TODO: signUpEmailがメールアドレスであるかどうか
      // TODO: signUpEmailがすでに他のユーザによって使われていないかどうか
      // TODO: signUpPasswordが英数字x字~y字であるかどうか
      // TODO: signUpIdが8文字の英小文字かどうか
      // TODO: signUpIdがdbのusers/identificationに含まれるか
      db.collection('Users')
        .where('identification', '==', signUpId)
        .get()
        .then((snapshot) => {
          if (snapshot.empty) {
            setMessage('仮IDが間違っています。');
            setIsLoading(false);
          } else if (snapshot.size === 1) {
            firebase
              .auth()
              .createUserWithEmailAndPassword(signUpEmail, signUpPassword)
              .then(() => {
                const user = firebase.auth().currentUser;
                const userID = user?.uid;
                let ID: string = '';
                let Admin: boolean = false;
                console.log(snapshot.docs[0].id);
                snapshot.forEach((doc) => {
                  ID = doc.id;
                  Admin = doc.data().isAdmin;
                });
                // db.Users/ID/userIDにUserIDを登録
                db.collection('Users')
                  .doc(ID)
                  .update({
                    userID: userID,
                  })
                  .then(() => {
                    if (Admin) {
                      props.turnOnIsAdminFlag();
                    }
                    props.goToPage('MyPage');
                  })
                  .catch((err) => {
                    console.error(err);
                    setMessage('会員データ紐づけ時にエラーが発生しました。');
                    setIsLoading(false);
                  });
              })
              .catch((err) => {
                console.error(err);
                setMessage('ユーザ登録時にエラーが発生しました。');
                setIsLoading(false);
              });
          } else {
            setMessage(
              '同じ仮IDを持った会員が複数人存在します。管理人に問い合わせてください。'
            );
            setIsLoading(false);
          }
        })
        .catch(() => {
          setMessage('仮IDの照合に失敗しました。');
          setIsLoading(false);
        });
    },
    [props, signUpId, signUpEmail, signUpPassword, privacyPolicyConfirmed]
  );

  const goToLoginPage = useCallback(() => {
    props.goToPage('LoginPage');
  }, [props]);

  const onChangeEmail = useCallback((event) => {
    setSignUpEmail(event.target.value);
  }, []);

  const onChangePassword = useCallback((event) => {
    setSignUpPassword(event.target.value);
  }, []);

  const onChangeId = useCallback((event) => {
    setSignUpId(event.target.value);
  }, []);

  const onChangePrivacyPolicyConfirmed = useCallback((event) => {
    setPrivacyPolicyConfirmed(event.target.checked);
  }, []);

  return (
    <Root>
      <H3>Togen-Meibo</H3>
      <Hr />
      <Explanation>
        このサイトは東京大学ピアノの会OBOG団体「桃源会」の会員専用サイトです。本サイトに関する質問やご意見などはtogen.meibo@gmail.comまでご連絡ください。
      </Explanation>
      <H3>初めての方</H3>
      <Hr />
      <Explanation>
        このページから桃源会の名簿管理システムに登録することができます。ログイン用Emailアドレス、ログイン用パスワード、桃源会役員からの連絡物に記載してある仮IDを入力し、新規登録ボタンをクリックしてください。
      </Explanation>
      <form onSubmit={onSignUpClick}>
        <TextField
          variant='filled'
          className={classes.textField}
          type='email'
          value={signUpEmail}
          onChange={onChangeEmail}
          label='Emailアドレス'
        />
        <TextField
          variant='filled'
          className={classes.textField}
          type='password'
          value={signUpPassword}
          onChange={onChangePassword}
          label='パスワード'
        />
        <TextField
          variant='filled'
          className={classes.textField}
          value={signUpId}
          onChange={onChangeId}
          label='仮ID'
        />
        <br />
        <br />
        <Box className={classes.privacyPolicy}>
          <H3>プライバシーポリシー</H3>
          桃源会（以下，「当会」といいます。）は，本ウェブサイト上で提供するサービス（以下,「本サービス」といいます。）における，ユーザーの個人情報の取扱いについて，以下のとおりプライバシーポリシー（以下，「本ポリシー」といいます。）を定めます。
          <H3>第1条（個人情報）</H3>
          「個人情報」とは，個人情報保護法にいう「個人情報」を指すものとし，生存する個人に関する情報であって，当該情報に含まれる氏名，生年月日，住所，電話番号，連絡先その他の記述等により特定の個人を識別できる情報及び容貌，指紋，声紋にかかるデータ，及び健康保険証の保険者番号などの当該情報単体から特定の個人を識別できる情報（個人識別情報）を指します。
          <H3>第2条（個人情報の収集・管理方法）</H3>
          当会は，ユーザーが当システムを利用する際に個人情報をお尋ねすることがあります。収集する個人情報(以下、名簿データという)は、名前、学歴、住所、連絡先(Email・電話番号・FAX)、勤務先、生年月日です。名前とログインメールアドレス以外の個人情報の登録は任意です。名簿データは桃源会役員の名簿担当が保管します。名簿担当の役員交代の際は、前任者が新任者に名簿データを渡し、交代時から1年間の間、前任者は名簿データを保管します。
          <H3>第3条（個人情報を収集・利用する目的）</H3>
          当会が個人情報を収集・利用する目的は，以下のとおりです。
          <br />
          1.当会サービスの提供・運営のため
          <br />
          2.ユーザーからのお問い合わせに回答するため（本人確認を行うことを含む）
          <br />
          3.ユーザーが利用中のサービスの新機能，更新情報の案内のメールを送付するため
          <br />
          4.メンテナンス，重要なお知らせなど必要に応じたご連絡のため
          <br />
          5.利用規約に違反したユーザーや，不正・不当な目的でサービスを利用しようとするユーザーの特定をし，ご利用をお断りするため
          <br />
          6.ユーザーにご自身の登録情報の閲覧や変更，削除，ご利用状況の閲覧を行っていただくため
          <br />
          7.上記の利用目的に付随する目的
          <H3>第4条（利用目的の変更）</H3>
          1.当会は，利用目的が変更前と関連性を有すると合理的に認められる場合に限り，個人情報の利用目的を変更するものとします。
          <br />
          2.利用目的の変更を行った場合には，変更後の目的について，当会所定の方法により，ユーザーに通知し，または本ウェブサイト上に公表するものとします。
          <H3>第5条（個人情報の第三者提供）</H3>
          1.当会は，次に掲げる場合を除いて，あらかじめユーザーの同意を得ることなく，第三者に個人情報を提供することはありません。ただし，個人情報保護法その他の法令で認められる場合を除きます。
          <br />
          1.1.人の生命，身体または財産の保護のために必要がある場合であって，本人の同意を得ることが困難であるとき
          <br />
          1.2.公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合であって，本人の同意を得ることが困難であるとき
          <br />
          1.3.国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって，本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき
          <br />
          1.4.予め次の事項を告知あるいは公表し，かつ当会が個人情報保護委員会に届出をしたとき
          <br />
          1.4.1. 利用目的に第三者への提供を含むこと
          <br />
          1.4.2. 第三者に提供されるデータの項目
          <br />
          1.4.3. 第三者への提供の手段または方法
          <br />
          1.4.4.本人の求めに応じて個人情報の第三者への提供を停止すること
          <br />
          1.4.5.本人の求めを受け付ける方法
          2.前項の定めにかかわらず，次に掲げる場合には，当該情報の提供先は第三者に該当しないものとします。
          2.1.当会が利用目的の達成に必要な範囲内において個人情報の取扱いの全部または一部を委託する場合
          2.2.個人情報を特定の者との間で共同して利用する場合であって，その旨並びに共同して利用される個人情報の項目，共同して利用する者の範囲，利用する者の利用目的および当該個人情報の管理について責任を有する者の氏名または名称について，あらかじめ本人に通知し，または本人が容易に知り得る状態に置いた場合
          <H3>第6条（個人情報の開示）</H3>
          1.当会は，本人から個人情報の開示を求められたときは，本人に対し，遅滞なくこれを開示します。ただし，開示することにより次のいずれかに該当する場合は，その全部または一部を開示しないこともあり，開示しない決定をした場合には，その旨を遅滞なく通知します。
          <br />
          1.1.本人または第三者の生命，身体，財産その他の権利利益を害するおそれがある場合
          <br />
          1.2. 当会の業務の適正な実施に著しい支障を及ぼすおそれがある場合
          <br />
          1.3.その他法令に違反することとなる場合
          <br />
          2.前項の定めにかかわらず，履歴情報および特性情報などの個人情報以外の情報については，原則として開示いたしません。
          <H3>第7条（個人情報の訂正および削除）</H3>
          1.ユーザーは，当会の保有する自己の個人情報が誤った情報である場合には，当会が定める手続きにより，当会に対して個人情報の訂正，追加または削除（以下，「訂正等」といいます。）を請求することができます。
          <br />
          2.当会は，ユーザーから前項の請求を受けてその請求に応じる必要があると判断した場合には，遅滞なく，当該個人情報の訂正等を行うものとします。
          <br />
          3.当会は，前項の規定に基づき訂正等を行った場合，または訂正等を行わない旨の決定をしたときは遅滞なく，これをユーザーに通知します。
          <br />
          <H3>第8条（個人情報の利用停止等）</H3>
          1.当会は，本人から，個人情報が，利用目的の範囲を超えて取り扱われているという理由，または不正の手段により取得されたものであるという理由により，その利用の停止または消去（以下，「利用停止等」といいます。）を求められた場合には，遅滞なく必要な調査を行います。
          <br />
          2.前項の調査結果に基づき，その請求に応じる必要があると判断した場合には，遅滞なく，当該個人情報の利用停止等を行います。
          <br />
          3.当会は，前項の規定に基づき利用停止等を行った場合，または利用停止等を行わない旨の決定をしたときは，遅滞なく，これをユーザーに通知します。
          <br />
          4.前2項にかかわらず，利用停止等に多額の費用を有する場合その他利用停止等を行うことが困難な場合であって，ユーザーの権利利益を保護するために必要なこれに代わるべき措置をとれる場合は，この代替策を講じるものとします。
          <br />
          <H3>第9条（プライバシーポリシーの変更）</H3>
          1.本ポリシーの内容は，法令その他本ポリシーに別段の定めのある事項を除いて，ユーザーに通知することなく，変更することができるものとします。
          <br />
          2.当会が別途定める場合を除いて，変更後のプライバシーポリシーは，本ウェブサイトに掲載したときから効力を生じるものとします。
          <H3>第10条（お問い合わせ窓口）</H3>
          本ポリシーに関するお問い合わせは，下記の窓口までお願いいたします。
          桃源会名簿担当：萩森 秀太 Eメールアドレス：togen.meibo@gmail.com
        </Box>
        <Checkbox
          color='primary'
          className={classes.checkbox}
          checked={privacyPolicyConfirmed}
          onChange={onChangePrivacyPolicyConfirmed}
        />
        桃源会プライバシーポリシーに同意する。
        <Box className={classes.message}>{message}</Box>
        <Button
          variant='contained'
          className={classes.button}
          onClick={goToLoginPage}
        >
          戻る
        </Button>
        <Button
          variant='contained'
          color='primary'
          className={classes.button}
          type='submit'
        >
          新規登録
        </Button>
        {isLoading ? ' 通信中...' : ''}
      </form>
    </Root>
  );
});
